<template>
  <div class="body-wrapper">
    <Headernav />
    <div class="w-full bg-gray-100">
      <div class="section">
        <div class="container text-center">
          <div class="section-title ext-gray-800 mb-3">MESSAGE SENDING SUCCESSFUL!</div>
          <div class="text-common text-gray-800 mb-12">Thank you for your kind interest in Gaerlan Manufacturing Incorporated. We will get back to you as soon as possible.</div>
          <div class="m-auto w-180"><router-link to="/"><div class="red-btn">Back To Home</div></router-link></div>
        </div>
      </div>
      <div class="w-full">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15438.834826593757!2d121.0390741!3d14.6724654!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8fa9e09c1aa298b6!2sGaerlan%20Manufacturing%2C%20Incorporated!5e0!3m2!1sen!2sph!4v1582793193288!5m2!1sen!2sph" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </div>
    </div>
    <div class="footer-wrapper bg-gray-900">
      <div class="container text-center text-white">
        <div class="w-full">Maintained and Developed by AMPH Advertising Agency Inc.</div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias for src
import Headernav from '@/components/Headernav.vue'
export default {
  components: {
    Headernav
  },
  mounted () {
    // Event snippet for Conversion Code conversion page
    // eslint-disable-next-line
    gtag('event', 'conversion', {'send_to': 'AW-763566832/UnroCKKXoJUBEPC1jOwC'});
  }
}
</script>
<style>
</style>
